﻿var IMSVueComponents = {};

var addressSuggestBs = require('./addressSuggestBs.vue');
var checkboxBs = require('./checkboxBs.vue');
var labelBs = require('./labelBs.vue');
var inputBs = require('./inputBs.vue');
var inputNumberBs = require('./inputNumberBs.vue');
var selectBs = require('./selectBs.vue');
var selectStringBs = require('./selectStringBs.vue');
var textAreaBs = require('./textAreaBs.vue');
var phoneBs = require('./phoneBs.vue');
var zipCodeBs = require('./zipCodeBs.vue');
var maskedInput = require('vue-text-mask');
var maskedInputBs = require('./maskedInputBs.vue');
var loading = require('./vueFullLoading.vue');
var objectToFormData = require('object-to-formdata');
var yesNo = require('./yesNo.vue');
var vmodal = require('vue-js-modal');

var project = require('./project.js');
project(IMSVueComponents);

IMSVueComponents.addressSuggestBs = addressSuggestBs;
IMSVueComponents.checkboxBs = checkboxBs;
IMSVueComponents.labelBs = labelBs;
IMSVueComponents.inputBs = inputBs;
IMSVueComponents.inputNumberBs = inputNumberBs;
IMSVueComponents.selectBs = selectBs;
IMSVueComponents.selectStringBs = selectStringBs;
IMSVueComponents.textAreaBs = textAreaBs;
IMSVueComponents.phoneBs = phoneBs;
IMSVueComponents.zipCodeBs = zipCodeBs;
IMSVueComponents.maskedInput = maskedInput.default;
IMSVueComponents.maskedInputBs = maskedInputBs;
IMSVueComponents.loading = loading;
IMSVueComponents.yesNo = yesNo;


IMSVueComponents.validationObserver  = VeeValidate.ValidationObserver;
IMSVueComponents.validationProvider = VeeValidate.ValidationProvider;

window.objectToFormData = objectToFormData;
window.IMSVueComponents = IMSVueComponents;

Vue.use(vmodal.default, { dialog: true });